import { ButtonGroup } from '@reveni-io/reveni-ui'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'

import { parcelPresentationTypes } from '../hooks/useParcelsPresentationType/constants'
import ParcelsCards from '../ParcelsCards/ParcelsCards'
import ParcelsListPageSkeleton from '../ParcelsListPageSkeleton/ParcelsListPageSkeleton'
import ParcelsTable from '../ParcelsTable/ParcelsTable'
import SelectAll from '../SelectAll/SelectAll'
import * as Styles from './styles'

const ParcelsListContent = ({
  loading,
  parcels,
  parcelPresentationType,
  parcelPresentationOptions,
  showBulkActions,
  selectedParcels,
  onSelectAll,
  onPrepare,
  onGeneratePackingList,
  onGeneratePickingList,
  preparableParcels,
  packableParcels,
  pickableParcels,
  onSelectParcel,
  getParcelDetailHref,
  onParcelDetailClick,
  parcelDetailSelectedId,
}) => {
  if (loading) {
    return <ParcelsListPageSkeleton presentationType={parcelPresentationType} />
  }

  if (!parcels?.results?.length) {
    return <NoResultsFound />
  }

  return (
    <>
      <Styles.ListHeaderContainer showBulkActions={showBulkActions}>
        {showBulkActions && (
          <SelectAll
            selectedParcels={selectedParcels}
            parcels={parcels?.results}
            onSelectAll={onSelectAll}
            onPrepare={onPrepare}
            onGeneratePackingList={onGeneratePackingList}
            onGeneratePickingList={onGeneratePickingList}
            preparableParcels={preparableParcels}
            packableParcels={packableParcels}
            pickableParcels={pickableParcels}
          />
        )}
        <ButtonGroup buttons={parcelPresentationOptions} active={parcelPresentationType} />
      </Styles.ListHeaderContainer>
      {parcelPresentationType === parcelPresentationTypes.rows && (
        <ParcelsCards
          parcels={parcels}
          onSelect={onSelectParcel}
          selectedParcels={selectedParcels}
          getParcelDetailHref={getParcelDetailHref}
          onParcelDetailClick={onParcelDetailClick}
          parcelDetailSelectedId={parcelDetailSelectedId}
        />
      )}
      {parcelPresentationType === parcelPresentationTypes.list && (
        <ParcelsTable
          parcels={parcels}
          onSelect={onSelectParcel}
          selectedParcels={selectedParcels}
          getParcelDetailHref={getParcelDetailHref}
          onParcelDetailClick={onParcelDetailClick}
          parcelDetailSelectedId={parcelDetailSelectedId}
        />
      )}
    </>
  )
}

export default ParcelsListContent
